<template>
  <div class="w-section section">
    <div class="w-container container with-fixed-block article-container">
      <div class="w-dyn-items">
        <div v-if="showArticles">
          <BlogPostItem
            v-for="post in posts"
            :key="post.id"
            :post="post"
          />
        </div>
        <div v-else>
          <div class="w-dyn-empty">
            <p>No items found.</p>
          </div>
        </div>
      </div>
      <div
        data-ix="show-fixed-block"
        class="fixed-block-container-wrapper"
      >
        <Sidebar />
      </div>
    </div>
  </div>
</template>

<script>
import BlogPostItem from '@/components/BlogPostItem'
import Sidebar from '@/components/TheSidebar'

export default {
  components: {
    BlogPostItem,
    Sidebar,
  },

  props: {
    posts: {
      required: true,
      type: Array,
    },
  },

  computed: {
    showArticles() {
      let show
      if (this.posts.length > 0) {
        show = true
      }
      return show
    },
  },
}
</script>

<style>
.article-container {
  min-height: 700px;
}
</style>
